export { default as ApfTranslate } from './apf.translate';
export { default as EtrTranslate } from './etr.translate';
export { default as PhonebookTranslate } from './phonebook.translate';
export { default as ThematicCardTranslate } from './ThematicCard.translate';
